import React, { useRef } from 'react';
import { Checkbox } from './ui/checkbox';

interface DataTableRowCheckboxProps {
  checked: boolean;
  rowId: string;
  ariaLabel: string;
  onSelectRange: (rowId: string) => void;
  onToggle: (rowId: string, selected: boolean) => void;
}

export const DataTableRowCheckbox: React.FC<DataTableRowCheckboxProps> = ({
  checked,
  rowId,
  ariaLabel,
  onSelectRange,
  onToggle,
}) => {
  const ignoreNextCheckedChangeRef = useRef(false);

  return (
    <div onClick={(event) => event.stopPropagation()}>
      <Checkbox
        checked={checked}
        aria-label={ariaLabel}
        onClick={(event) => {
          event.stopPropagation();
          if (!event.shiftKey) {
            return;
          }
          event.preventDefault();
          ignoreNextCheckedChangeRef.current = true;
          onSelectRange(rowId);
          queueMicrotask(() => {
            ignoreNextCheckedChangeRef.current = false;
          });
        }}
        onCheckedChange={(value) => {
          if (ignoreNextCheckedChangeRef.current) {
            ignoreNextCheckedChangeRef.current = false;
            return;
          }
          onToggle(rowId, !!value);
        }}
      />
    </div>
  );
};
